import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Grid from "material-ui/Grid";
import Paper from "material-ui/Paper";
import Typography from "material-ui/Typography";

import MediaCard from "./../../components/MediaCard/MediaCard";
import SummaryCard from "./../../components/SummaryCard/SummaryCard";
import LinearLoader from "./../../components/LinearLoader/LinearLoader";
import UnitsTable from "./../../components/UnitsTable/UnitsTable";
import DatetimePicker from "./../../components/DatetimePicker/DatetimePicker";
import GrowTransition from "./../../components/GrowTransition/GrowTransition";
import FilterTable from "./../../components/FilterTable/FilterTable";
import {
  formatDateString,
  formatDateTimeString
} from "./../../utilities/datesFormatter";
import hasTP from "./../../utilities/unitsFilters";
import Sequence from "./../../utilities/sequence";

import "react-table/react-table.css";
import "./Gas.css";
import FetchButton from "../../components/FetchButton/FetchButton";
import DownloadAs from "./../../components/DownloadAs/DownloadAs";
import AlertMessage from "./../../components/AlertMessage/AlertMessage";
import StartImage from "./../../images/start-marker.png";
import EndImage from "./../../images/end-marker.png";
import ComparativeCard from "./../../components/ComparativeCard/ComparativeCard";

import TotalServicesImage from "./../../images/gas/IconosGas-01.svg";
import TotalServedImage from "./../../images/gas/IconosGas-02.svg";
import VisitedCustomersImage from "./../../images/gas/IconosGas-03.svg";
import DiscountSalesImage from "./../../images/gas/IconosGas-04.svg";
import TotalSalesImage from "./../../images/gas/IconosGas-05.svg";
import UnitWithMostServicesImage from "./../../images/gas/IconosGas-06.svg";
import UnitWithLeastServicesImage from "./../../images/gas/IconosGas-07.svg";
import BestCustomerImage from "./../../images/gas/IconosGas-08.svg";

// import TotalServicesIcon from "./../../images/gas/"

import {
  buildClientsColumns,
  buildServicesColumns,
  buildServicesEventsColumns
} from "./builders";
import { Button } from "material-ui";

class GasView extends Component {
  render() {
    const {
      lang,
      units,
      isLoading,
      permissions,
      loadedPermissions,
      hasData,
      fetchData,
      reportData,
      comparativeReporData,
      handleCloseAlertMessage,
      alertMessage,
      isAlertMessageOpen,
      firstLocationDate,
      lastLocationDate,
      downloadExcel,
      downloadPdf,
      services,
      handleCompare,
      isInComparativeMode
    } = this.props;

    const fechaPrimerUbicacion = formatDateTimeString(firstLocationDate);
    const fechaUltimaUbicacion = formatDateTimeString(lastLocationDate);
    let isMultiple = false;

    let clients = [];
    let clientsColumns;
    let servicesColumns;
    let servicesEventsColumns;

    if (hasData) {
      isMultiple = reportData.Resultados.length > 1;
      clients = reportData.TotalClientesVisitados;
      clientsColumns = buildClientsColumns(lang);
      servicesColumns = buildServicesColumns(lang);
      servicesEventsColumns = buildServicesEventsColumns(lang);
    }

    const sequence = new Sequence(0, 50);
    const duration = 50;

    return (
      <div className="gas">
        {loadedPermissions && !permissions.Gas && <Redirect to={"./"} push />}

        {isLoading && <LinearLoader />}

        <div className="root">
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="grid-item"
            >
              <DownloadAs
                disabled={!(hasData && !isLoading)}
                xls={true}
                pdf={true}
                pdfClick={downloadPdf}
                xlsClick={downloadExcel}
              />
            </Grid>
          </Grid>
        </div>
        <div className="root">
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="grid-item"
            >
              <UnitsTable units={units.filter(v => hasTP(v, [".servicio"]))} />
            </Grid>
          </Grid>
        </div>

        <div className="root">
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="grid-item"
            >
              <Paper className="margin-top-bottom rounded" elevation={4}>
                <Grid container>
                  <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
                    <DatetimePicker />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className="fetch-button-container">
                      <FetchButton
                        disabled={isLoading}
                        onClick={fetchData}
                        text={lang.Consultar}
                      />
                    </div>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </div>

        {hasData && (
          <div className="root">
            <Grid container spacing={24}>
              <Grid
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                item
                className="grid-item"
              >
                <Typography
                  variant="headline"
                  align="center"
                  color="primary"
                  className="headline"
                >
                  {isMultiple
                    ? lang.Resumen
                    : reportData.Resultados[0].UnidadDescripcion}
                  {/* <Button
                    style={{ float: "right" }}
                    variant="raised"
                    color="primary"
                    onClick={handleCompare}
                  >
                    {isInComparativeMode ? "Individual" : "Comparar"}
                  </Button> */}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="grid-item"
              >
                <GrowTransition
                  in={!isLoading}
                  delay={sequence.next()}
                  duration={duration}
                >
                  <Paper className="summary rounded" elevation={4}>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={3}
                        lg={3}
                        xl={3}
                        className="grid-item"
                      >
                        <SummaryCard
                          title={lang.Inicio}
                          value={fechaPrimerUbicacion[0]}
                          units={fechaPrimerUbicacion[1]}
                          imageUrl={StartImage}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={3}
                        lg={3}
                        xl={3}
                        className="grid-item"
                      >
                        <SummaryCard
                          title={lang.Fin}
                          value={fechaUltimaUbicacion[0]}
                          units={fechaUltimaUbicacion[1]}
                          imageUrl={EndImage}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={3}
                        lg={3}
                        xl={3}
                        className="grid-item"
                      >
                        <SummaryCard
                          title={lang.TotalServicios}
                          value={reportData.TotalServicios.length}
                          imageUrl={TotalServicesImage}
                          imageWidth={"4rem"}
                          imageHeight={"4rem"}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={3}
                        lg={3}
                        xl={3}
                        className="grid-item"
                      >
                        <SummaryCard
                          title={lang.KilosLitrosDespachados}
                          value={reportData.TotalKilosServidos + " Kgs."}
                          units={reportData.TotalLitrosServidos + " lts."}
                          imageUrl={TotalServedImage}
                          imageWidth={"5rem"}
                          imageHeight={"5rem"}
                        />
                      </Grid>
                    </Grid>
                  </Paper>
                </GrowTransition>
              </Grid>
            </Grid>
          </div>
        )}

        {hasData && (
          <div className="root">
            <Grid container>
              {!isInComparativeMode && (
                <React.Fragment>
                  <GrowTransition
                    in={!isLoading}
                    delay={sequence.next()}
                    duration={duration}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      md={4}
                      lg={4}
                      xl={4}
                      className="grid-item"
                    >
                      <MediaCard
                        title={lang.ClientesVisitados}
                        imageUrl={VisitedCustomersImage}
                        imageTitle={lang.ClientesVisitados}
                        value={reportData.TotalClientesVisitados.length}
                        className="media-green"
                      />
                    </Grid>
                  </GrowTransition>
                  <GrowTransition
                    in={!isLoading}
                    delay={sequence.next()}
                    duration={duration}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      md={4}
                      lg={4}
                      xl={4}
                      className="grid-item"
                    >
                      <MediaCard
                        title={lang.VentasConDescuento}
                        imageUrl={DiscountSalesImage}
                        imageTitle={lang.VentasConDescuento}
                        value={reportData.TotalVentasDescuento}
                        className="media-red"
                      />
                    </Grid>
                  </GrowTransition>
                  <GrowTransition
                    in={!isLoading}
                    delay={sequence.next()}
                    duration={duration}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      md={4}
                      lg={4}
                      xl={4}
                      className="grid-item"
                    >
                      <MediaCard
                        title={lang.TotalVenta}
                        imageUrl={TotalSalesImage}
                        imageTitle={lang.TotalVenta}
                        value={"$" + reportData.TotalVentas.toFixed(2)}
                        className="media-green"
                      />
                    </Grid>
                  </GrowTransition>

                  {isMultiple && (
                    <React.Fragment>
                      <GrowTransition
                        in={!isLoading}
                        delay={sequence.next()}
                        duration={duration}
                      >
                        <Grid
                          item
                          xs={12}
                          sm={4}
                          md={4}
                          lg={4}
                          xl={4}
                          className="grid-item"
                        >
                          <MediaCard
                            title={lang.UnidadConMasServicios}
                            imageUrl={UnitWithMostServicesImage}
                            imageTitle={lang.UnidadConMasServicios}
                            value={
                              reportData.UnidadConMasServicios.Servicios.length
                            }
                            subValue={
                              reportData.UnidadConMasServicios.UnidadDescripcion
                            }
                            className="media-green"
                          />
                        </Grid>
                      </GrowTransition>
                      <GrowTransition
                        in={!isLoading}
                        delay={sequence.next()}
                        duration={duration}
                      >
                        <Grid
                          item
                          xs={12}
                          sm={4}
                          md={4}
                          lg={4}
                          xl={4}
                          className="grid-item"
                        >
                          <MediaCard
                            title={lang.UnidadConMenosServicios}
                            imageUrl={UnitWithLeastServicesImage}
                            imageTitle={lang.UnidadConMenosServicios}
                            value={
                              reportData.UnidadConMenosServicios.Servicios
                                .length
                            }
                            subValue={
                              reportData.UnidadConMenosServicios
                                .UnidadDescripcion
                            }
                            className="media-red"
                          />
                        </Grid>
                      </GrowTransition>
                      <GrowTransition
                        in={!isLoading}
                        delay={sequence.next()}
                        duration={duration}
                      >
                        <Grid
                          item
                          xs={12}
                          sm={4}
                          md={4}
                          lg={4}
                          xl={4}
                          className="grid-item"
                        >
                          <MediaCard
                            title={lang.MejorCliente}
                            imageUrl={BestCustomerImage}
                            imageTitle={lang.MejorCliente}
                            value={
                              "$" +
                              reportData.MejorCliente.PrecioTotal.toFixed(2)
                            }
                            subValue={reportData.MejorCliente.Cliente}
                            className="media-green"
                          />
                        </Grid>
                      </GrowTransition>
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
              {isInComparativeMode && (
                <React.Fragment>
                  <GrowTransition
                    in={!isLoading}
                    delay={sequence.next()}
                    duration={duration}
                  >
                    <Grid xs={12} sm={12} md={12} lg={12} xl={12} item>
                      <Grid container>
                        <Grid xs={12} sm={6} md={4} lg={4} xl={4} item>
                          <ComparativeCard
                            bottomValue={
                              reportData.TotalClientesVisitados.length
                            }
                            bottomTitle={fechaPrimerUbicacion[0]}
                            topValue={reportData.TotalClientesVisitados.length}
                            topTitle={fechaPrimerUbicacion[0]}
                          />
                        </Grid>
                        <Grid xs={12} sm={6} md={4} lg={4} xl={4} item>
                          <ComparativeCard
                            bottomValue={reportData.TotalVentasDescuento}
                            bottomTitle={fechaPrimerUbicacion[0]}
                            topValue={reportData.TotalVentasDescuento}
                            topTitle={fechaPrimerUbicacion[0]}
                            iconColor="#ea5455"
                          />
                        </Grid>
                        <Grid xs={12} sm={6} md={4} lg={4} xl={4} item>
                          <ComparativeCard
                            bottomValue={"$" + reportData.TotalVentas}
                            bottomTitle={fechaPrimerUbicacion[0]}
                            topValue={"$" + reportData.TotalVentas}
                            topTitle={fechaPrimerUbicacion[0]}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </GrowTransition>
                  {isMultiple && (
                    <GrowTransition
                      in={!isLoading}
                      delay={sequence.next()}
                      duration={duration}
                    >
                      <Grid xs={12} sm={12} md={12} lg={12} xl={12} item>
                        <Grid container>
                          <Grid xs={12} sm={6} md={4} lg={4} xl={4} item>
                            <ComparativeCard
                              bottomValue={
                                reportData.UnidadConMasServicios.Servicios
                                  .length
                              }
                              bottomTitle={fechaPrimerUbicacion[0]}
                              topValue={
                                reportData.UnidadConMasServicios.Servicios
                                  .length
                              }
                              topTitle={fechaPrimerUbicacion[0]}
                            />
                          </Grid>
                          <Grid xs={12} sm={6} md={4} lg={4} xl={4} item>
                            <ComparativeCard
                              bottomValue={
                                reportData.UnidadConMenosServicios.Servicios
                                  .length
                              }
                              bottomTitle={fechaPrimerUbicacion[0]}
                              topValue={
                                reportData.UnidadConMenosServicios.Servicios
                                  .length
                              }
                              topTitle={fechaPrimerUbicacion[0]}
                              iconColor="#ea5455"
                            />
                          </Grid>
                          <Grid xs={12} sm={6} md={4} lg={4} xl={4} item>
                            <ComparativeCard
                              bottomValue={
                                "$" + reportData.MejorCliente.PrecioTotal
                              }
                              bottomTitle={fechaPrimerUbicacion[0]}
                              topValue={
                                "$" + reportData.MejorCliente.PrecioTotal
                              }
                              topTitle={fechaPrimerUbicacion[0]}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </GrowTransition>
                  )}
                </React.Fragment>
              )}

              {isMultiple && (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  item
                  className="grid-item"
                >
                  <GrowTransition
                    in={!isLoading}
                    delay={sequence.next()}
                    duration={duration}
                  >
                    <Grid container>
                      <FilterTable
                        data={reportData.Resultados}
                        lang={lang}
                        columns={servicesEventsColumns}
                        defaultPageSize={5}
                        filterable={true}
                        tableHeader={lang.EventosDeServicio}
                        className="-striped -highlight borderless"
                      />
                    </Grid>
                  </GrowTransition>
                </Grid>
              )}

              {!isMultiple && (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  item
                  className="grid-item"
                >
                  <GrowTransition
                    in={!isLoading}
                    delay={sequence.next()}
                    duration={duration}
                  >
                    <Grid container>
                      <FilterTable
                        lang={lang}
                        data={services}
                        columns={servicesColumns}
                        defaultPageSize={5}
                        filterable={true}
                        tableHeader={lang.Servicios}
                        className="-striped -highlight borderless"
                      />
                    </Grid>
                  </GrowTransition>
                </Grid>
              )}

              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                item
                className="grid-item"
              >
                <GrowTransition
                  in={!isLoading}
                  delay={sequence.next()}
                  duration={duration}
                >
                  <Grid container>
                    <FilterTable
                      data={clients}
                      lang={lang}
                      columns={clientsColumns}
                      defaultPageSize={5}
                      filterable={true}
                      tableHeader={lang.ClientesVisitados}
                      className="-striped -highlight borderless"
                    />
                  </Grid>
                </GrowTransition>
              </Grid>
            </Grid>
          </div>
        )}

        <AlertMessage
          open={isAlertMessageOpen}
          message={alertMessage}
          handleClose={handleCloseAlertMessage}
        />
      </div>
    );
  }
}

export default GasView;



// WEBPACK FOOTER //
// ./src/containers/Gas/GasView.js